import { AlertCircle, CheckCircle, AlertTriangle } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';

export const ComplianceBadge = ({ status, missingCount = 0, expiredCount = 0, expiringSoonCount = 0 }) => {
  const normalizedStatus = typeof status === 'string' ? status.toLowerCase() : '';
  let statusColor = 'bg-green-100 text-green-700 border-green-200';
  let Icon = CheckCircle;
  let label = 'MOT Pass';
  let tooltip = 'All MOT requirements met';

  if (normalizedStatus === 'bypassed' || normalizedStatus === 'disabled') {
    statusColor = 'bg-slate-100 text-slate-700 border-slate-200';
    Icon = AlertTriangle;
    label = 'MOT Disabled';
    tooltip = 'SIYAK MOT checks are disabled for this property';
  } else if (normalizedStatus === 'due') {
    statusColor = 'bg-red-100 text-red-700 border-red-200';
    Icon = AlertCircle;
    label = 'MOT Due';
    tooltip = expiredCount > 0
      ? `${expiredCount} expired document${expiredCount !== 1 ? 's' : ''}`
      : 'One or more MOT documents are overdue';
  } else if (normalizedStatus === 'fail' || normalizedStatus === 'non-compliant') {
    statusColor = 'bg-red-100 text-red-700 border-red-200';
    Icon = AlertCircle;
    label = 'MOT Fail';
    tooltip = `${missingCount} outstanding MOT requirement${missingCount !== 1 ? 's' : ''}`;
  } else if (normalizedStatus === 'advisory' || normalizedStatus === 'warning') {
    statusColor = 'bg-amber-100 text-amber-700 border-amber-200';
    Icon = AlertTriangle;
    label = 'Advisory';
    tooltip = expiringSoonCount > 0
      ? `${expiringSoonCount} document${expiringSoonCount !== 1 ? 's' : ''} expiring soon`
      : 'Some MOT actions are still outstanding';
  } else if (!normalizedStatus && (status === 'non-compliant' || missingCount > 0)) {
    statusColor = 'bg-red-100 text-red-700 border-red-200';
    Icon = AlertCircle;
    label = 'MOT Due';
    tooltip = `${missingCount} outstanding MOT requirement${
      missingCount !== 1 ? 's' : ''
    }${expiredCount > 0 ? ` and ${expiredCount} expired` : ''}`;
  } else if (!normalizedStatus && (status === 'warning' || expiredCount > 0 || expiringSoonCount > 0)) {
    statusColor = 'bg-amber-100 text-amber-700 border-amber-200';
    Icon = AlertTriangle;
    label = 'Advisory';
    tooltip = expiredCount > 0
      ? `${expiredCount} expired document${expiredCount !== 1 ? 's' : ''}${expiringSoonCount > 0 ? ` and ${expiringSoonCount} expiring soon` : ''}`
      : `${expiringSoonCount} document${expiringSoonCount !== 1 ? 's' : ''} expiring soon`;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border ${statusColor} cursor-help`}
          >
            <Icon className="w-4 h-4" />
            <span className="text-sm font-medium">{label}</span>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
